import React, { useState, useEffect } from "react";
import ReportsSection from "../components/ReportDropdown2";
import LanguageSelector from "../components/LangugageSelector";
import PersonalInfoForm from "../components/PersonalInfoForm";
import OrganizationForm from "../components/OrganizationForm";
import IndustrySection from "../components/IndustrySection";
import { useNavigate } from 'react-router-dom';
import MembershipSection from "../components/MembershipSection";
import SectionD from "../components/SectionD";
import SectionDnew from "../components/SectionDnew";
import BackgroundInfoSection from "../components/BackgroundInfoSection";
import LocationPicker from "./LocationPicker";
import { motion, AnimatePresence } from "framer-motion";
import Profile from "../components/Profile";
import ProductService from "../components/ProductService";
import GroupExperience from "../components/GroupExperience";
import Modal from "react-modal";
import SaveButtonWithModal from "../components/SaveButtonWithModel";
// Update your Firebase imports at the top of the file
import { 
    getFirestore, 
    setDoc, 
    doc, 
    getDoc,
    collection,
    query,
    where,
    limit,
    getDocs
  } from "firebase/firestore";
import {
    getAuth,
    createUserWithEmailAndPassword,
    fetchSignInMethodsForEmail,
} from "firebase/auth";
import { generateRegistrationNumber } from "../utils/generateRegNumber";
import { uploadToCloudinary } from "../utils/CloudinaryUpload";
import { sendRegistrationEmail } from "../utils/sendRegistrationsEmail";
import { initializeApp } from "firebase/app";
import { firebaseConfig } from "../firebase"; // Make sure `firebaseConfig` is exported from your firebase.js
import { signInWithEmailAndPassword } from "firebase/auth";
import OrganizationForm1 from "../components/OrganizationForm1";

// Init Firebase singletons
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const dropdownItems = {
    FACILITATOR: [
        "Individual (IN)",
        "Entrepreneur (EN)",
        "Learners (LN)",
        "Moderator (MO)",
        "Facilitator (FA)",
        "Assessor (AS)",
        "Evaluator (EV)",
        "Training provider (TR)",
        "Cooperative (CO)",
        "Community (CM)",
        "EIA",
    ],
    PURPOSE: [
        "Funding",
        "Training",
        "Resourcing",
        "Market",
        "M&E",
        "Assessment",
        "Evaluations",
        "Impact",
    ],
};
Modal.setAppElement("#root"); // Replace '#root' with the ID of your root element

const initialReportSelections = {
    COUNTRY: "SOUTH AFRICA",
    REGION: "Eastern Cape",
    MUNICIPALITY: "Johannesburg",
    TYPE: "Learners",
    "VALUE CHAIN": "Maize",
    PROJECT: "ABATTOIR",
};

const Dropdown = ({ label, items, type, isProjectDropdown, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selected, setSelected] = useState(items[0]);
    const [selectedCircles, setSelectedCircles] = useState({});

    const toggleCircle = (item) => {
        setSelectedCircles((prev) => ({
            ...prev,
            [item]: !prev[item],
        }));
    };

    const handleSelect = (item) => {
        setSelected(item);
        setIsOpen(false);
        if (typeof onChange === "function") {
            onChange(type, item);
            // Show in console exactly when user selects:
            console.log(`Selected ${type}:`, item);
        }
    };

    return (
        <div className="flex flex-col w-full relative">
            {/* Button */}
            <div className="flex relative z-20 w-fit">
                <button
                    onClick={() => {
                        if (
                            isProjectDropdown &&
                            selected?.toLowerCase() === "funding"
                        ) {
                            window.location.href = "/funding";
                        } else {
                            setIsOpen((prev) => !prev);
                        }
                    }}
                    className={`xl:w-[240px] lg:w-[240px] md:w-[90px] w-[50px] h-[15px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                    <span className="md:text-[18px] md:px-2 text-[4px] md:mt-0 mt-[2px]">
                        {selected}
                    </span>
                </button>
                <div
                    className="w-[15px] h-[15px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
                    onClick={() => setIsOpen((prev) => !prev)}>
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745014174/Expand_down_3_ggzyur.png"
                        alt="expand"
                        className="w-2 h-[10px] md:w-6 md:h-[24px]"
                    />
                </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                    <motion.ul
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        className="absolute top-full mt-1 left-0 z-50 md:w-[220px] w-[70px] border-[1px] border-[#979797]/80 bg-white rounded-[1px] shadow-lg p-2">
                        <li className="flex items-center justify-between px-2 py-1 mb-2">
                            <span className="text-[6px] md:text-[20px] font-semibold">
                                Registration - Type of users
                            </span>
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
                                alt="icon"
                                className="md:w-[30px] md:h-[30px] h-[7px] w-[7px]"
                            />
                        </li>
                        {items.map((item, index) => (
                            <li
                                key={index}
                                className={`flex items-center justify-between md:px-3 px-1 md:py-2 py-1 md:mt-1 rounded-md hover:bg-gray-100 cursor-pointer ${selected === item ? "bg-[#E7EBEB]" : ""}`}
                                onClick={() => handleSelect(item)}>
                                <span className="text-black text-[4px] md:text-[18px]">
                                    {item}
                                </span>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleCircle(item);
                                    }}
                                    className={`w-2 h-2 md:w-8 md:h-8 rounded-full ${selected === item ? "bg-[#03897B]" : "bg-gray-200"}`}></div>
                            </li>
                        ))}
                    </motion.ul>
                )}
            </AnimatePresence>
            <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
                {isProjectDropdown
                    ? "Select PURPOSE"
                    : `Select ${type === "FACILITATOR" ? "user type" : label}`}
            </p>
        </div>
    );
};

const languages = [
    "Owned",
    "Commonage",
    "Community Owned",
    "Municipal Land",
    "House with a plot",
    "Urban lot",
    "Community Food garden allocation",
    "No Land Yet",
];
const languages1 = [
    "Leased",
    "Community Leased",
    "Road side vacant land",
    "Village / Local/ Tribunal Authority allocation",
];

const RegisterOrganizaton = () => {
    const [selected, setSelected] = useState(null); // <-- initially nothing selected
    const [selected1, setSelected1] = useState(null); // <-- initially nothing selected
    const [selectedBox, setSelectedBox] = useState(null);
    const keys = Object.keys(dropdownItems);
    const handleBoxClick = (index) => {
        setSelectedBox(index);
    };
    const setLandSizes = (newSizes) => {
        console.log("New sizes: ", newSizes);
    };
    const [isSaveModalOpen, setIsSaveModalOpen] = useState(false); // Save modal state
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false); // Registration modal state
    // Save Button Click Handler
    const handleSaveClick = () => {
        const dataToSave = {
            formData,
            orgFormData,
            dropdownSelections,
            reportSelections,
            selectedLanguage,
            landType1,
            landType2,
            erfNumber,
            selectedSkills,
            selectedMembership,
            selectedExperience,
            focusSelected,
            selectedType,
            selectedOption,
            selectedCategories,
            selectedChallenges,
            vision,
            selectedS,
            selectedQ,
            location,
        };
        localStorage.setItem("registrationData", JSON.stringify(dataToSave));
        setIsSaveModalOpen(true); // Open Save modal
    };
    const navigate = useNavigate();
    const [landData, setLandData] = useState({
        type1: { type: "", size: "", unit: "Hectare", hasLandSize: false },
        type2: { type: "", size: "", unit: "Hectare", hasLandSize: false },
        erfNumber: ''
      });
const [userLocation, setUserLocation] = useState(null);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Edit modal state
    const [loginEmail, setLoginEmail] = useState(""); // Email input state
    const [loginPassword, setLoginPassword] = useState(""); // Password input state
    const [loginError, setLoginError] = useState(null); // Login error state
    // Handle Login from "Edit" Pop-up
    const handleLogin = async () => {
        try {
            setLoading(true);
            setLoginError(null); // Clear any previous errors

            // Attempt to sign in with email and password
            const userCredential = await signInWithEmailAndPassword(
                auth,
                loginEmail,
                loginPassword,
            );
            const userDoc = await getDoc(
                doc(db, "registrations", userCredential.user.uid),
            );

            if (userDoc.exists()) {
                const userData = userDoc.data();
                setFormData(userData.personalInfo || {}); // Populate form with user data
                setOrgFormData(userData.organizationInfo || {}); // Populate organization form data
                setDropdownSelections(userData.dropdownSelections || {});
                setReportSelections(userData.reportSelections || {});
                setSelectedLanguage(userData.language || null);
                setLandType1(userData.background?.landType1 || "");
                setLandType2(userData.background?.landType2 || "");
                setErfNumber(userData.background?.erfNumber || "");
                setSelectedSkills(userData.profingSkills || []);
                setSelectedMembership(userData.membership || "");
                setSelectedExperience(userData.groupExperience || []);
                setFocusSelected(userData.sectionD?.focusSelected || []);
                setSelectedType(userData.sectionD?.selectedType || "");
                setSelectedOption(userData.sectionD?.selectedOption || "Maize");
                setSelectedCategories(
                    userData.sectionD?.selectedCategories || [],
                );
                setSelectedChallenges(
                    userData.industry?.selectedChallenges || [],
                );
                setVision(userData.industry?.vision || "");
                setSelectedS(userData.setaQualification?.selectedS || "Agri");
                setSelectedQ(
                    userData.setaQualification?.selectedQ ||
                        "Business Administration",
                );
                setLocation(userData.location || null);

                setIsLoggedIn(true); // Mark user as logged in
                setIsEditModalOpen(false); // Close the modal upon successful login
                console.log("Login successful! User data loaded.");
            } else {
                console.error("No such document exists for the logged-in user.");
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);

            // Provide feedback for login failure
            if (error.code === "auth/user-not-found") {
                setLoginError("No account found with this email.");
            } else if (error.code === "auth/wrong-password") {
                setLoginError("Incorrect password. Please try again.");
            } else {
                setLoginError(
                    "An error occurred during login. Please try again later.",
                );
            }

            console.error("Login failed:", error);
        }
    };
    // Close Save Modal
    const closeSaveModal = () => {
        setIsSaveModalOpen(false);
    };

    // Close Registration Modal
    const closeRegisterModal = () => {
        setIsRegisterModalOpen(false);
    };
    const [certificatesUrls, setCertificatesUrls] = useState([]);
    const [idDocumentUrl, setIdDocumentUrl] = useState("");
    const [dropdownSelections, setDropdownSelections] = useState({
        user_type: dropdownItems.FACILITATOR[0],
        user_purpose: dropdownItems.PURPOSE[0],
    });
    const [landType1, setLandType1] = useState("");
    const [landType2, setLandType2] = useState("");
    const [erfNumber, setErfNumber] = useState("");
    const [productImages, setProductImages] = useState([]);
    const [showMembershipSections, setShowMembershipSections] = useState(false);
    const [membershipData, setMembershipData] = useState({
        selected: "",
        custom: ""
    }); // Initialize membershipData before usage
    const [selectedS, setSelectedS] = useState("Agri"); // initial SETA
    const [selectedQ, setSelectedQ] = useState("Business Administration"); // initial Qualification
    const [showDropdownError, setShowDropdownError] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login status

    const handleDropdownSave = (data) => {
        // Log all values from the dropdowns in registration page
        console.log(" SETA and Qualification:", data);
        // data = { SETA: "Bank", QUALIFICATIONS: "IT Technical Support" }
    };
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const clearAllFormData = () => {
        // Clear all form states
        setFormData({
          firstName: "",
          surname: "",
          dateOfBirth: "",
          typeOfId: "",
          idNumber: "",
          mobile: "",
          email: "",
          password: "",
          whatsapp: "",
          physicalAddress: "",
          postalCode: "",
        });
        
        setOrgFormData({
          cooperativeName: "",
          registrationNumber: "",
          members: "",
          mobileNumber: "",
          physicalAddress: "",
          chairFirstName: "",
          chairSurname: "",
          secretaryFirstName: "",
          secretarySurname: "",
          email: "",
          password: "",
        });
        
        setDropdownSelections({
          user_type: dropdownItems.FACILITATOR[0],
          user_purpose: dropdownItems.PURPOSE[0],
        });
        
        setReportSelections(initialReportSelections);
        setSelectedLanguage(null);
        setLandType1("");
        setLandType2("");
        setErfNumber("");
        setSelectedSkills([]);
        setSelectedMembership("");
        setSelectedExperience([]);
        setFocusSelected([]);
        setSelectedType("");
        setSelectedOption("Maize");
        setSelectedCategories([]);
        setSelectedChallenges([]);
        setVision("");
        setSelectedS("Agri");
        setSelectedQ("Business Administration");
        setLocation(null);
        setProfileImage(null);
        setProductImages([]);
        setAgreed(false);
        
        // Clear from localStorage
        localStorage.removeItem("registrationData");
        
        // Close the modal
        setIsDeleteModalOpen(false);
        
        console.log("All registration data has been cleared");
      };
  const validateFarmerRegistration = async (farmerRegNumber) => {
    try {
      const farmerDoc = await getDoc(doc(db, "registrations", farmerRegNumber));
      if (!farmerDoc.exists()) {
        return { isValid: false, error: "Invalid farmer registration number" };
      }
      
      const farmerData = farmerDoc.data();
      if (farmerData.registrationType !== "farmer") {
        return { isValid: false, error: "The provided number is not a farmer registration" };
      }

      return { isValid: true, farmerData };
    } catch (error) {
      console.error("Error validating farmer registration:", error);
      return { isValid: false, error: "Error validating registration number" };
    }
  };
 
  const onHandleSave = async () => {
    if (!agreed) {
      setRegistrationError("Please agree to the terms and conditions.");
      return;
    }
  
    setLoading(true);
    setProgressMsg("Saving...");
    setRegistrationError(null);
  
    const email = orgFormData.email;
    const password = orgFormData.password;
  
    try {
      // Create Firebase Auth user
      let userCredential;
      try {
        userCredential = await createUserWithEmailAndPassword(auth, email, password);
        console.log("Firebase Auth user created:", userCredential.user.uid);
      } catch (authError) {
        if (authError.code === 'auth/email-already-in-use') {
          setRegistrationError("This email is already registered");
          setLoading(false);
          return;
        }
        throw authError;
      }
  
      // Generate registration number with proper selections
      const regNumber = generateRegistrationNumber({
        COUNTRY: reportSelections?.COUNTRY || 'SOUTH AFRICA',
        TYPE: '(ORG)' // Explicitly set organization type
      });
  
      console.log("Generated Registration Number:", regNumber);
  
      // Create organization payload
      const organizationPayload = {
        registrationType: "organization",
        registrationNumber: regNumber,
        createdAt: new Date().toISOString(),
        createdBy: userCredential.user.uid,
        email: email,
        status: "active",
        
        // Organization Info
        organizationInfo: {
          name: orgFormData.cooperativeName,
          regNumber: orgFormData.registrationNumber,
          members: orgFormData.members,
          mobileNumber: orgFormData.mobileNumber,
          physicalAddress: orgFormData.physicalAddress,
          chairPerson: {
            firstName: orgFormData.chairFirstName,
            surname: orgFormData.chairSurname
          },
          secretary: {
            firstName: orgFormData.secretaryFirstName,
            surname: orgFormData.secretarySurname
          },
          type: orgType,
          certificates: certificatesUrls,
          idDocument: idDocumentUrl
        },
        
        // Other details
        userType: dropdownSelections.user_type,
        userPurpose: dropdownSelections.user_purpose,
        reportSelections: reportSelections,
        language: selectedLanguage,
        location: savedLocation
      };
  
      // Save to organizations collection
      await setDoc(doc(db, "organizations", userCredential.user.uid), organizationPayload);
      console.log("Organization data saved successfully");
  
      // Send registration email
      await sendRegistrationEmail({
        user_name: orgFormData.cooperativeName,
        registration_number: regNumber,
        user_email: email,
        user_type: "Organization",
        name: orgFormData.cooperativeName,
        email: email
      });
  
      // Success
      setLoading(false);
      setRegistrationNumber(regNumber);
      setIsModalOpen(true);
  
    } catch (error) {
      console.error("Registration Error:", error);
      setLoading(false);
      setRegistrationError(
        error.message || "An error occurred during registration. Please try again."
      );
    }
  };
    const handleBackgroundSave = (data) => {
        // Log all background info
        console.log("Background Info:", data);
    };
    const handleDropdownChange = (type, value) => {
        // Map dropdown type to your desired object keys
        const keyMap = {
            FACILITATOR: "user_type",
            PURPOSE: "user_purpose",
        };

        const mappedKey = keyMap[type];

        setDropdownSelections((prev) => ({
            ...prev,
            [mappedKey]: value,
        }));

        // Log only the mapped keys and latest values
        console.log({
            user_type:
                type === "FACILITATOR" ? value : dropdownSelections.user_type,
            user_purpose:
                type === "PURPOSE" ? value : dropdownSelections.user_purpose,
        });
    };
    const [selectedChallenges, setSelectedChallenges] = useState([]);
    const [vision, setVision] = useState("");

    const handleIndustrySave = (data) => {
        console.log("Industry Activity Survey:", data);
        // {
        //   cooperativeName: ...,
        //   section: ...,
        //   vision: ...,
        //   selectedChallenges: [...]
        // }
    };
    const [selectedExperience, setSelectedExperience] = useState([]);
    const [focusSelected, setFocusSelected] = useState([]);
    const [selectedType, setSelectedType] = useState("");
    const [showBackgroundError, setShowBackgroundError] = useState(false);
    // When the user clicks Register
    // Handle Registration
    const handleRegister = async () => {
      if (isLoggedIn) {
        console.log("User is already logged in. Updating user details...");
        try {
          await updateUserDetails();
          setRegistrationError(null);
          setRegistrationNumber("Your details have been updated successfully!");
          setIsModalOpen(true);
        } catch (error) {
          console.error("Error updating user details:", error);
          setRegistrationError(
            "An error occurred while updating your details. Please try again."
          );
        }
        return;
      }
    
      try {
        setLoading(true);
        setRegistrationError(null);
    
        const signInMethods = await fetchSignInMethodsForEmail(
          auth,
          formData.email
        );
        if (signInMethods.length > 0) {
          setRegistrationError(
            "This email is already registered. Please log in instead."
          );
          setLoading(false);
          return;
        }
    
        const userCredential = await createUserWithEmailAndPassword(
          auth,
          formData.email,
          formData.password
        );
        const uid = userCredential.user.uid;
    
        // Generate registration number based on selections
        const regNumber = generateRegistrationNumber({
          COUNTRY: reportSelections.COUNTRY,
          TYPE: dropdownSelections.user_type
        });
    
        console.log("Generated Registration Number:", regNumber);
    
        await saveUserData(uid, regNumber);
    
        await sendRegistrationEmail({
          user_name: `${formData.firstName} ${formData.surname}`,
          registration_number: regNumber,
          user_email: formData.email,
          user_type: dropdownSelections.user_type,
          name: `${formData.firstName} ${formData.surname}`,
          email: formData.email,
        });
    
        setRegistrationNumber(regNumber);
        setIsModalOpen(true);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Registration error:", error);
    
        if (error.code === "auth/email-already-in-use") {
          setRegistrationError("Error - Email already in use / taken");
        } else if (error.code === "auth/weak-password") {
          setRegistrationError("Error - Password is too weak");
        } else if (error.code === "auth/invalid-email") {
          setRegistrationError("Error - Invalid email address");
        } else if (error.code === "auth/missing-password") {
          setRegistrationError("Error - Missing password");
        } else {
          setRegistrationError("An error occurred during registration.");
        }
      }
    };
    const handleFocusSave = (data) => {
        console.log("Areas of Focus:", data);
        // {
        //   cooperativeName: ...,
        //   typeOfFocus: ...,
        //   selectedAreas: [...],
        //   selectedDisabilityType: ...
        // }
    };
    // Save User Data to Firestore
    const saveUserData = async (uid, regNumber) => {
        const userPayload = {
            personalInfo: { ...formData },
            organizationInfo: { ...orgFormData },
            dropdownSelections,
            reportSelections,
            language: selectedLanguage,
            background: { landType1, landType2, erfNumber },
            profingSkills: selectedSkills,
            membership: selectedMembership,
            groupExperience: selectedExperience,
            sectionD: {
                focusSelected,
                selectedType,
                selectedOption,
                selectedCategories,
            },
            industry: { selectedChallenges, vision },
            setaQualification: { selectedS, selectedQ },
            location,
            registrationNumber: regNumber,
            createdAt: new Date().toISOString(),
        };

        console.log("Saving to Firestore:", userPayload); // Debugging output

        await setDoc(doc(db, "registrations", uid), userPayload);
        console.log("User data saved to Firestore successfully.");
    };
    // Update Existing User Data
    const updateUserDetails = async () => {
        const user = auth.currentUser; // Get the currently logged-in user
        if (user) {
            const userDocRef = doc(db, "registrations", user.uid); // Reference to the user's document in Firestore
            const updatedPayload = {
                personalInfo: { ...formData },
                organizationInfo: { ...orgFormData },
                dropdownSelections,
                reportSelections,
                language: selectedLanguage,
                background: { landType1, landType2, erfNumber },
                profingSkills: selectedSkills,
                membership: selectedMembership,
                groupExperience: selectedExperience,
                sectionD: {
                    focusSelected,
                    selectedType,
                    selectedOption,
                    selectedCategories,
                },
                industry: { selectedChallenges, vision },
                setaQualification: { selectedS, selectedQ },
                location,
                updatedAt: new Date().toISOString(), // Add a timestamp for updates
            };

            // Save updated data to Firestore
            await setDoc(userDocRef, updatedPayload, { merge: true }); // Merge updated data with existing document
            console.log("User details updated successfully.");
        } else {
            console.error("No logged-in user found.");
            throw new Error("User not logged in.");
        }
    };

    const [selectedOption, setSelectedOption] = useState("Maize");
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [profileImage, setProfileImage] = useState(null);

    const handleSectionDSave = (data) => {
        // data = { typeOfOrganization: ..., categories: [...] }
        console.log("Section D Industry Interest:", data);
    };

    const handleGroupExperienceSave = (data) => {
        console.log("Group Experience:", data);
        // Example:
        // {
        //   cooperativeName: 'YourCooperativeName',
        //   typeOfGroupExperience: 'Personal, Group or Cooperative Experience',
        //   selectedExperience: [...]
        // }
    };

    // ProfingSkils state
    const [agreed, setAgreed] = useState(false);
    const [showAgreementError, setShowAgreementError] = useState(false); // State for showing error
    const [selectedSkills, setSelectedSkills] = useState([]);
    const [selectedMembership, setSelectedMembership] = useState(""); // e.g. "AFASA" or "Others"
    const handleMembershipSave = (value) => {
        // Example: add more keys if needed
        console.log("Membership/Affiliation Selected:", value);
    };
    const handleProfingSkillsSave = (skills) => {
        // Example: log with cooperative name and type if you have them
        const data = {
            PersonalSkillsTrainingandQualifications:
                "PersonalSkillsTrainingandQualifications", // replace/fetch as needed
            typeOfProfingSkill: "Personal Skills Training and Qualifications",
            selectedSkills: skills,
        };
        console.log("Profing Skills:", data);
    };
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [showProfileSections, setShowProfileSections] = useState(false);

    // Add your main save handler (use the same function as your Register button)
    const [savedLocation, setSavedLocation] = useState(null);

    // Call this when Register button is clicked
    const handleRegisterSave = () => {
        const cooperative = {
            // ...other registration fields,
            location: savedLocation,
        };
        console.log("location:", cooperative);
        // ...show modal, etc.
    };

    const [location, setLocation] = useState(null);

    // This gets called when "Save Location" is clicked inside LocationPicker
    const [locationCountry, setLocationCountry] = useState("");

    const handleSaveLocation = (country) => {
        setLocationCountry(country);
        console.log("User selected country:", country);
    };

    const [showUnits, setShowUnits] = useState(false);
    const [selectedUnit, setSelectedUnit] = useState("Hectare");
    const [landSize, setLandSize] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [copyMessage, setCopyMessage] = useState("");

    const [selected3, setSelected3] = useState("Organization");

    const handleCopy = () => {
        navigator.clipboard.writeText("ZA25-582-9511");
        setCopyMessage("Copied!"); // Set the "Copied!" message

        // Hide the message after 2 seconds
        setTimeout(() => {
            setCopyMessage("");
        }, 2000);
    };
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const units = ["Hectare", "Acre", "Square Meter"];

    const handleUnitSelect = (unit) => {
        setSelectedUnit(unit);
        setShowUnits(false);
    };

    // Report dropdown state
    const [isExpanded, setIsExpanded] = useState(false);

    const [reportSelections, setReportSelections] = useState(
        initialReportSelections,
    );

    // Handler for report dropdowns
    const handleReportDropdownChange = (type, value) => {
        setReportSelections((prev) => {
            const updated = { ...prev, [type]: value };
            // Log with readable keys (convert keys if you want)
            console.log({
                country: updated.COUNTRY,
                region: updated.REGION,
                municipality: updated.MUNICIPALITY,
                type: updated.TYPE,
                value_chain: updated["VALUE CHAIN"],
                project: updated.PROJECT,
            });
            return updated;
        });
    };
    const [selectedLanguage, setSelectedLanguage] = useState(null);

    const handleLanguageChange = (lang) => {
        setSelectedLanguage(lang);
        console.log("Selected language:", lang);
    };
    const [formData, setFormData] = useState({
        firstName: "",
        surname: "",
        dateOfBirth: "",
        typeOfId: "",
        idNumber: "",
        mobile: "",
        email: "",
        password: "",
        whatsapp: "",
        physicalAddress: "",
        postalCode: "",
    });
    const [race, setRace] = useState("");
    const [gender, setGender] = useState("");
    const [disability, setDisability] = useState("");

    // Log all values here when Save is clicked in PersonalInfoForm
    const handlePersonalInfoSave = (data) => {
        console.log("Personal Info Form Data:", data);
    };
    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
      };
    const [orgFormData, setOrgFormData] = useState({
        cooperativeName: "",
        registrationNumber: "",
        members: "",
        mobileNumber: "",
        physicalAddress: "",
        chairFirstName: "",
        chairSurname: "",
        secretaryFirstName: "",
        secretarySurname: "",
        email: "",
        password: "",
    });
    const [orgType, setOrgType] = useState("COOPERATIVE 1");

    const handleOrgSave = (data) => {
        // This logs all org fields to the console
        console.log("Organization Form Data:", data);
    };

    const [loading, setLoading] = useState(false);
    const [progressMsg, setProgressMsg] = useState("");
    const [registrationError, setRegistrationError] = useState(null);
    const [registrationNumber, setRegistrationNumber] = useState("");


    // Load saved data from local storage on component mount
    useEffect(() => {
        const savedData = JSON.parse(localStorage.getItem("registrationData"));
        if (savedData) {
            setFormData(savedData.formData || {});
            setOrgFormData(savedData.orgFormData || {});
            setDropdownSelections(savedData.dropdownSelections || {});
            setReportSelections(
                savedData.reportSelections || initialReportSelections,
            );
            setSelectedLanguage(savedData.selectedLanguage || null);
            setLandType1(savedData.landType1 || "");
            setLandType2(savedData.landType2 || "");
            setErfNumber(savedData.erfNumber || "");
            setSelectedSkills(savedData.selectedSkills || []);
            setSelectedMembership(savedData.selectedMembership || "");
            setSelectedExperience(savedData.selectedExperience || []);
            setFocusSelected(savedData.focusSelected || []);
            setSelectedType(savedData.selectedType || "");
            setSelectedOption(savedData.selectedOption || "Maize");
            setSelectedCategories(savedData.selectedCategories || []);
            setSelectedChallenges(savedData.selectedChallenges || []);
            setVision(savedData.vision || "");
            setSelectedS(savedData.selectedS || "Agri");
            setSelectedQ(savedData.selectedQ || "Business Administration");
            setLocation(savedData.location || null);
        }
    }, []);

    // Updated handleRegisterClick to reset the error state
    const handleRegisterClick = () => {
        if (!agreed) {
            setShowAgreementError(true); // Show error if not agreed
            return;
        }
        setShowAgreementError(false);

        // Clear any previous errors before attempting registration
        setRegistrationError(null);

        onHandleSave(); // Proceed with registration logic
    };
    // Example: Reset error when typing in the email or password fields
    const handleFormInputChange = (field, value) => {
        setFormData((prev) => ({
            ...prev,
            [field]: value,
        }));
        setRegistrationError(null); // Clear the error when the user starts typing
    };

    return (
        <div className="bg-white">
            <div className="md:px-28 px-4">
                {/* Header Section */}
                <div className="w-full mx-auto md:pt-12 pt-4">
                    <h2 className="text-center font-bold text-[14px] md:text-[54px]">
                        Registration as a farmer
                    </h2>
                    <div className="md:mt-5 mt-3 relative">
                        <div className="relative">
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745662169/image_34_nw6w6z.png"
                                alt="Farmland"
                                className="w-full object-cover md:h-[400px]"
                            />
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745662260/image_1716_vhpofl.png"
                                alt="FarmNet Logo"
                                className="absolute md:bottom-4 left-3 bottom-1 md:left-8 md:w-[170px] w-[80px] h-auto"
                            />
                        </div>
                        <div
                            className="w-full flex items-center md:h-20 h-8 justify-between md:px-8 px-3 mt-0"
                            style={{
                                backgroundColor: "#D9D9D9",
                                borderBottomLeftRadius: "5px",
                                borderBottomRightRadius: "5px",
                            }}>
                            <span className="font-bold text-[8px] md:text-[32px]">
                            Why register as  as an organization ?
                            </span>
                            <img
                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745662579/Expand_right_2x_t7csdp.png"
                                alt="Expand"
                                className="md:w-[45px] w-[20px] h-[20px] md:h-[47px]"
                            />
                        </div>
                    </div>
                    <h1 className="text-[#E7EBEB] md:text-[36px] font-bold md:mt-6 md:mb-6">
                        REGISTRATION{" "}
                        <span className="text-[#152C24]">| ORGANIZATION</span>
                    </h1>
                </div>

                <div className=" w-full  mx-auto md:pt-1 pt-2">
                    {/* Labels directly above the bar */}
                    <div>
                        <div className="relative w-full mx-auto h-[40px] md:mb-4 md:mt-3 mb-0">
                    <a href="Register_As_Farm">
                    <span
                                className={`absolute top-0 left-[25%] sm:left-[25%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${
                                    selected3 === "Individual"
                                        ? "text-black"
                                        : "text-black"
                                }`}
                                onClick={() => setSelected3("Individual")}>
                                Individual
                            </span>
                    </a>

                            <a href="/RegisterOrganization">
                                <span
                                    className={`absolute top-0 left-[75%] sm:left-[75%] -translate-x-1/2 text-[8px] sm:text-[36px] font-bold cursor-pointer transition-colors duration-200 ${
                                        selected3 === "Organization"
                                            ? "text-black"
                                            : "text-black"
                                    }`}
                                    onClick={() => setSelected3("Organization")}>
                                    Organization
                                </span>
                            </a>
                        </div>

                        {/* Toggle Bar */}
                        <div className="w-full md:h-[10px] h-[4px] bg-[#D9D9D9] flex rounded-[10px] overflow-hidden md:mt-0 mb-2 -mt-5 md:mb-6 mx-auto">
                            {/* Individual Side */}

                <a href="Register_As_Farm"
                                className="w-1/2 h-full cursor-pointer relative"
                                onClick={() => setSelected3("Individual")}>
                                <div
                                    className={`absolute inset-0 transition-all duration-300 bg-[#D9D9D9] rounded-[10px]`}></div>
                            </a>
             
                            {/* Organization Side */}
                   
                                <div
                                    className="w-1/2 h-full cursor-pointer relative"
                                    onClick={() => setSelected3("Organization")}>
                                    <div
                                        className={`absolute inset-0 transition-all  bg-[#152C24] duration-300  rounded-[10px]`}></div>
                                </div>
                        </div>
                    </div>

                    <div className="flex justify-between items-center w-full ">
                        {/* LEFT SIDE - HEADING */}
                        <div>
                            <div className="flex-1 md:mt-2">
                                <div>
                                    <div className="flex md:flex-row items-start md:gap-4 gap-1 ">
                                        <a href="/SMEChallenges">
                                            <div className="md:w-[300px] w-[80px] md:max-w-[310px]">
                                                <button className="w-full h-[20px] text-white md:h-[60px] text-left rounded-[5px] px-2 md:px-4 bg-[#152C24] border-b-[4px] border-[#EEB527] text-[5px] md:text-[20px] font-bold">
                                                    Entrepreneurs challenges
                                                </button>
                                                <p className="text-[4px] md:text-[16px] leading-tight font-normal mt-1">
                                                    Click to read entrepreneurs{" "}
                                                    <br /> challenges
                                                </p>
                                            </div>
                                        </a>

                                        <div className="md:w-full w-[80px] md:max-w-[300px]">
                                            <a href="/BenefitsOfRegistration">
                                                <button className="w-full h-[20px]  text-white md:h-[60px] text-left px-1 md:px-4 rounded-[5px] bg-[#152C24] border-b-[4px] border-[#EEB527] text-[5px] md:text-[20px] font-bold">
                                                    Benefits of registration
                                                </button>
                                            </a>
                                            <p className="text-[4px] md:text-[16px] font-normal mt-1">
                                                Click to read benefits of
                                                registration
                                                <br />
                                                <span className="text-transparent">
                                                    sss
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT SIDE - DROPDOWNS */}
                        <div className="flex gap-4 flex-wrap justify-end md:-mt-5 ">
                            {keys.map((type, index) => {
                                const customLabels = {
                                    Crop: "Crop Report",
                                    Livestock: "Livestock Report",
                                    Type: "Type of Report",
                                };

                                const displayLabel = customLabels[type] || type;
                                const isProjectDropdown =
                                    index === keys.length - 1;

                                return (
                                    <div key={type} className="w-auto">
                                        <Dropdown
                                            label={displayLabel}
                                            items={dropdownItems[type]}
                                            type={type}
                                            isProjectDropdown={isProjectDropdown}
                                            onChange={handleDropdownChange}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <ReportsSection
                        values={reportSelections}
                        onChange={handleReportDropdownChange}
                    />
                    {/* 
          <OfficialNews /> */}
                </div>
               
                <OrganizationForm1
                    formData={orgFormData}
                    onFormDataChange={setOrgFormData}
                    selectedOption={orgType}
                    onOptionChange={setOrgType}
                    onCertificatesUrlChange={setCertificatesUrls} // Receive certificate URLs
                    onIdUrlChange={setIdDocumentUrl} // Receive ID document URL
                    onSave={setOrgFormData}
                />
                <div className="w-full md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] relative">
  {/* Left placeholder for spacing */}
  <div className="w-[154px] h-[70px] sm:w-[100px] sm:h-[100px]"></div>

  {/* Centered Text */}
  <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-[12px] font-bold">
    PROFILE
  </div>

  {/* Right Box - Toggle Button */}
  <div 
    className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black cursor-pointer"
    onClick={() => setShowProfileSections(!showProfileSections)}
  >
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${showProfileSections ? 'v1748785688/Expand_down_yilqh4.png' : 'v1748785688/Expand_down_yilqh4.png'}`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>
                              {showProfileSections && (
  <>
    <Profile
      formData={orgFormData}
      onProfileImageChange={(imageData) => {
        setProfileImage(imageData);
        setFormData(prev => ({
          ...prev,
          profileImage: imageData.cloudinaryUrl || imageData.previewUrl
        }));
      }}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
    
    <ProductService
      formData={orgFormData}
      onProductImagesChange={setProductImages}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
    
    <OrganizationForm
      formData={orgFormData}
      onFormDataChange={setOrgFormData}
      selectedOption={orgType}
      onOptionChange={setOrgType}
      onCertificatesUrlsChange={setCertificatesUrls}
      onIdUrlChange={setIdDocumentUrl}
      onSave={setOrgFormData}
    />
  </>
)}

                <BackgroundInfoSection
                    languages={languages}
                    languages1={languages1}
                    setLandSizes={setLandSizes} // Pass it as a prop
                    selected={landType1}
                    setSelected={setLandType1}
                    selected1={landType2}
                    setSelected1={setLandType2}
                    erfNumber={erfNumber}
                    showError={showBackgroundError}
                    setErfNumber={setErfNumber}
                    onSave={handleBackgroundSave}
                />
                <div></div>

                <div>
                <div className="md:mt-5 mt-2 w-full md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] relative">
  {/* Left placeholder for spacing */}
  <div className="w-[154px] h-[70px] sm:w-[100px] sm:h-[100px]"></div>

  {/* Centered Text */}
  <div className="absolute md:text-[32px] text-[20px] font-bold">
    <div>
      <h3 className="font-bold text-black text-[8px] md:text-[32px]">
        Memberships, Affiliations, Groups and Associations
      </h3>
      <p className="md:text-[24px] text-[6px] italic font-normal text-black">
        What other organization groups or affiliations are you a member of, or are involved with:
      </p>
    </div>
  </div>

  {/* Right Box - Toggle Button */}
  <div 
    className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black cursor-pointer"
    onClick={() => setShowMembershipSections(!showMembershipSections)}
  >
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${showMembershipSections ? 'v1748785688/Expand_down_yilqh4.png' : 'v1748785688/Expand_down_yilqh4.png'}`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>
{showMembershipSections && (
  <>
    <MembershipSection
      selectedMembership={membershipData.selected}
      setSelectedMembership={(value) =>
        setMembershipData((prev) => ({ ...prev, selected: value }))
      }
      onSave={(data) => {
        if (data.type === 'selected') {
          setFormData(prev => ({ ...prev, selectedMembership: data.value }));
        } else if (data.type === 'custom') {
          setFormData(prev => ({ ...prev, customMembership: data.value }));
        }
      }} 
    />

    <GroupExperience
      selectedExperience={selectedExperience}
      setSelectedExperience={setSelectedExperience}
      onSave={(data) => {
        console.log("Group Experience Data:", data);
        setSelectedExperience(data.selectedExperience);
      }}
    />
  </>
)}
     
                    <SectionDnew
                        selected={focusSelected}
                        setSelected={setFocusSelected}
                        selectedType={selectedType}
                        setSelectedType={setSelectedType}
                        onSave={handleFocusSave}
                    />
              
               
              <div 
  className="w-full md:mt-5 mt-3  md:h-[133px] h-[70px] flex items-center justify-between border-b border-[#979797] bg-white rounded-b-[1px] rounded-[10px] md:mt-7 relative cursor-pointer"
  onClick={toggleExpand}
>
  <div className="w-[154px] h-[70px] sm:w-[70px] sm:h-[100px]"></div>
  <div className="absolute left-1/2 transform -translate-x-1/2 md:text-[32px] text-center text-[10px] font-bold">
    INDUSTRY ACTIVITY SURVEY
  </div>
  <div className="md:w-[154px] md:h-[133px] w-[100px] h-[70px] bg-[#D9D9D9] rounded-br-[10px] flex items-center justify-center border-b border-black">
    <img
      src={`https://res.cloudinary.com/dzngpgki4/image/upload/${
        isExpanded 
          ? 'v1748785688/Expand_down_yilqh4.png' 
          : 'v1748785688/Expand_down_yilqh4.png'
      }`}
      alt="expand icon"
      className="md:w-12 md:h-12 w-6 h-6"
    />
  </div>
</div>

{isExpanded && (
  <>
    <IndustrySection
      selected={selectedChallenges}
      setSelected={setSelectedChallenges}
      vision={vision}
      setVision={setVision}
      onSave={(data) => {
          console.log("Industry data saved:", data);
          setSelectedChallenges(data.selectedChallenges);
          setVision(data.vision);
      }}
    />
    
    {/* Location Section */}
    <div className="md:mt-3 flex items-center space-x-3">
      <img
        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744662306/image_1570_pnbwi8.png"
        alt=".."
        className="md:w-[37px] w-[17px] h-[17px] md:h-[37px]"
      />
      <h1 className="md:text-[36px] text-[10px] font-bold">
        Set Location
      </h1>
    </div>
    <div className="h-auto w-full rounded-md mt-3">
      <LocationPicker onSaveLocation={handleSaveLocation} />
    </div>
  </>
)}

<div className="flex gap-4 items-center mt-5">
                                <div
                                    className="md:w-16 md:h-[63px] w-6 h-[30px] rounded-[5px] bg-[#D9D9D9] flex items-center justify-center cursor-pointer transition"
                                    onClick={() => {
                                        setAgreed((prev) => !prev);
                                        setShowAgreementError(false); // Clear error when checkbox is clicked
                                    }}
                                    tabIndex={0}
                                    aria-pressed={agreed}
                                    aria-label="Confirm terms and conditions">
                                    {/* Black or Green Check Round Fill SVG */}
                                    {agreed ? (
                                        // GREEN CHECK ROUND FILL
                                        <svg
                                            width="54"
                                            height="54"
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="27"
                                                cy="27"
                                                r="27"
                                                fill="#152C24"
                                            />
                                            <path
                                                d="M39 21L24.75 35L15 25.4545"
                                                stroke="white"
                                                strokeWidth="4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    ) : (
                                        // BLACK CHECK ROUND FILL
                                        <svg
                                            width="54"
                                            height="54"
                                            viewBox="0 0 54 54"
                                            fill="none"
                                            className="md:w-[54px] md:h-[54px] w-[20px] h-[20px] transition-all duration-150"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle
                                                cx="27"
                                                cy="27"
                                                r="27"
                                                fill="#222"
                                            />
                                            <path
                                                d="M39 21L24.75 35L15 25.4545"
                                                stroke="white"
                                                strokeWidth="4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>
                                    )}
                                </div>
                                <p className="md:text-[20px] text-[6px]">
                                    By ticking I confirm that I agree with the{" "}
                                    <a
                                        className="underline hover:text-[#152C24]"
                                        href="/TermsAndCondition">
                                        Terms and conditions
                                    </a>
                                    ,<a href="/DataPolicy"     className="underline hover:text-[#152C24]">Data </a>and{" "}
                                    <a
                                        className="underline hover:text-[#152C24]"
                                        href="/PrivacyPolicy">
                                        Privacy policy
                                    </a>
                                    .
                                       <p
                                className={`md:text-[14px] text-[10px] ${
                                    agreed
                                        ? "text-white hidden "
                                        : " text-red-600 cursor-not-allowed"
                                }`}>
                                Please agree to the terms and conditions before
                                proceeding.
                            </p>
                                </p>

                         

                            {/* Text */}
                        </div>

                   {/* Register Button */}
                   <button
  onClick={handleRegisterClick}
  disabled={loading || !agreed}
  className={`w-full flex justify-center md:text-[28px] text-[8px] mt-1 font-bold items-center md:mt-14 border-b-[3px] md:py-1 py-1 text-center md:h-[74px] h-[20px] ${
    agreed && !loading
      ? "bg-[#152C24] text-white border-[#FDBD26]"
      : "bg-gray-400 text-gray-200 border-gray-300 cursor-not-allowed"
  }`}
>
  {loading ? "Processing..." : "Register"}
</button>
       <div className="flex flex-col justify-end md:mt-4  ">
                                {/* Buttons */}
                                <div className="flex md:gap-4 gap-1  justify-end mt-2">

                                 {/* Save Button */}
                                 <div>
                                        {/* Save Button */}
                                        {/* Delete Button */}
<div>
    <button
        className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#FDBB26] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
        onClick={() => setIsDeleteModalOpen(true)}>
        <span>DELETE</span>
        <img 
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png" 
            alt="Delete" 
            className="md:w-[30px] h-[6px] md:h-[30px] w-[6px]"
        />
    </button>
    <p className="md:text-[14px] text-[6px] mt-1 font-normal md:px-1">
        Delete registration 
    </p>
</div>

                                        {/* Save Confirmation Modal */}
                                       {/* Delete Confirmation Modal */}
<Modal
    isOpen={isDeleteModalOpen}
    onRequestClose={() => setIsDeleteModalOpen(false)}
    contentLabel="Delete Confirmation"
    className="modal-content"
    overlayClassName="modal-overlay">
    <button
        onClick={() => setIsDeleteModalOpen(false)}
        className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
        aria-label="Close">
        &times;
    </button>
    <div>
        <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
            <div className="flex flex-col items-center justify-center text-center w-[300px]  h-full md:w-full">
                <div className="relative mb-4 w-full flex justify-center items-center">
                    <img
                        src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279697/Trash_1_afo0yz.png"
                        alt="Delete"
                        className="w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                    />
                </div>
                <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                    Confirm Deletion
                </div>
                <p className="text-black text-[10px] md:text-[32px] mb-2">
                    Are you sure you want to delete this registration?
                </p>
                <p className="text-black text-[10px] md:text-[24px] mb-6">
                    This action cannot be undone.
                </p>
                <div className="flex gap-4 w-full justify-center">
                    <button
                        onClick={() => setIsDeleteModalOpen(false)}
                        className="bg-gray-300 hover:bg-gray-400 text-[12px] md:text-[32px] text-black w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                        Cancel
                    </button>
                    <button
  onClick={() => {
    clearAllFormData();
    setIsDeleteModalOpen(false);
  }}
  className="bg-red-500 hover:bg-red-600 text-[12px] md:text-[32px] text-white  w-[130px] md:w-[300px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
  Delete
</button>
                </div>
            </div>
        </div>
    </div>
</Modal>

                                        {/* Registration Confirmation Modal */}
                                        <Modal
                                            isOpen={isRegisterModalOpen}
                                            onRequestClose={closeRegisterModal}
                                            contentLabel="Registration Successful"
                                            className="modal-content"
                                            overlayClassName="modal-overlay">
                                            <button
                                                onClick={closeRegisterModal}
                                                className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
                                            <div>
                                                <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
                                                    <div className="flex flex-col items-center justify-center text-center h-full w-full">
                                                        <div className="relative mb-4 w-full flex justify-center items-center">
                                                            <img
                                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                                                alt="Success"
                                                                className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                                            />
                                                            <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                                                Registration
                                                                Successful
                                                            </div>
                                                        </div>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-2">
                                                            Thank you for
                                                            registering with
                                                            Ad-Luck
                                                        </p>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-4">
                                                            Your unique
                                                            registration number
                                                            is:
                                                        </p>
                                                        <div className="flex items-center justify-between w-full mb-6 mt-8 px-4">
                                                            <div className="flex-1 flex justify-center">
                                                                <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                                                                    {
                                                                        registrationNumber
                                                                    }
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        registrationNumber,
                                                                    );
                                                                    setCopyMessage(
                                                                        "Copied!",
                                                                    );
                                                                    setTimeout(
                                                                        () =>
                                                                            setCopyMessage(
                                                                                "",
                                                                            ),
                                                                        2000,
                                                                    );
                                                                }}
                                                                className="bg-[#F38323] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                                                Copy
                                                            </button>
                                                        </div>
                                                        {copyMessage && (
                                                            <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                                                {copyMessage}
                                                            </div>
                                                        )}
                                                        <a href="/">
                                                            <button
                                                                onClick={
                                                                    closeRegisterModal
                                                                }
                                                                className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                                Continue to Home
                                                            </button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>
                                    {/* Edit Button */}
                                    <div>
                                        <button
                                            className="flex items-center justify-between md:w-[190px] w-[60px] md:h-[44px] h-[15px] bg-[#2E453D] text-white md:text-[14px] md:px-4 px-1 text-[6px] font-bold rounded-[5px]"
                                            onClick={() =>
                                                setIsEditModalOpen(true)
                                            }>
                                            <span>EDIT</span>
                                            <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
                                                alt="Edit Icon"
                                                className="md:w-[30px] h-2  md:h-[30px] w-2"
                                            />
                                        </button>

                                        <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1 ">
                                            Edit registration form
                                        </p>
                                        <Modal
                                            isOpen={isEditModalOpen}
                                            onRequestClose={() =>
                                                setIsEditModalOpen(false)
                                            }
                                            contentLabel="Login to Edit"
                                            className="modal-content bg-[#E7EBEB]  w-[350px] md:w-[600px]"
                                            overlayClassName="modal-overlay ">
                                            {/* Close Button */}
                                            <button
                                                onClick={() =>
                                                    setIsEditModalOpen(false)
                                                }
                                                className="absolute top-2 right-2 md:top-4 md:right-4 text-black opacity-50 hover:opacity-100 text-[12px] md:text-[30px] font-bold z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
<div className="flex justify-end"> 
    <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748281140/image_aorywu.png" alt="hi" className="md:w-[120px] md:mt-10 md:h-[22px]"/>
</div>
                                            <div className="md:p-4 p-2 md:py-20">
                                                <h2 className=" md:text-[40px] font-extrabold mb-4">
                                                Farm IT , Digitalize IT!

                                                </h2>
                                                <div>
                                                 
                                                    <input
                                                        type="email"
                                                        value={loginEmail}
                                                        placeholder="Enter Email address"
                                                        onChange={(e) =>
                                                            setLoginEmail(
                                                                e.target.value,
                                                            )
                                                        }
                                                        className="w-full text-[10px] shadow-inner shadow-black/40 md:text-[20px] bg-[#155528] focus:bg-[#155528] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px]  md:px-6 "
                                                    />
                                                </div>
                                                <div className="mt-2">
                                                   
                                                    <input
                                                        type="password"
                                                        value={loginPassword}
                                                        placeholder="Enter password"
                                                        onChange={(e) =>
                                                            setLoginPassword(
                                                                e.target.value,
                                                            )
                                                        }
                                              className="w-full text-[10px] inner-shadow shadow-black md:text-[20px] bg-[#155528] focus:bg-[#155528] text-white placeholder:text-white placeholder:font-bold rounded-md placeholder:pl-1 mb-4 p-2 h-[48px] md:h-[66px]  md:px-6 "
                                                    />
                                                </div>
                                                {loginError && (
                                                    <p className="text-red-500 text-sm mt-2">
                                                        {loginError}
                                                    </p>
                                                )}
                                                {isLoggedIn && (
                                                    <p className="text-green-500 text-sm mt-2">
                                                        Login successful!
                                                    </p>
                                                )}
                                                <div className="mt-6 flex justify-between gap-3 md:gap-8">
                                                    <button
                                                        onClick={() =>
                                                            setIsEditModalOpen(
                                                                false,
                                                            )
                                                        }
                                                        className="bg-gray-300  shadow-inner shadow-black/40 font-bold  text-black text-[8px] md:text-[20px] w-full px-4 md:py-4 py-2 rounded-md">
                                                        Cancel
                                                    </button>
                                                    <button
                                                        onClick={handleLogin}
                                                        className="bg-[#FDBB26]  shadow-inner shadow-black/40 font-bold md:text-[20px] text-[8px] text-white w-full px-4 md:py-4 rounded-md">
                                                        {loading
                                                            ? "Logging in..."
                                                            : "Login"}
                                                    </button>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>

                                    {/* Save Button */}
                                    <div>
                                        {/* Save Button */}
                                        <div>
                                            <button
                                                className="flex items-center justify-between w-[60px] md:w-[190px] h-[15px] md:h-[44px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[5px] px-1 md:px-4"
                                                onClick={handleSaveClick}>
                                                <span>SAVE ALL</span>
                                                <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748279791/Arhive_load_duotone_line_ukwrm4.png"
                                                alt="Edit Icon"
                                                className="md:w-[30px] h-[6px]  md:h-[30px] w-[6px]"
                                            />
                                            </button>
                                            <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1">
                                                Save registration
                                            </p>
                                        </div>

                                        {/* Save Confirmation Modal */}
                                        <Modal
                                            isOpen={isSaveModalOpen}
                                            onRequestClose={closeSaveModal}
                                            contentLabel="Save Successful"
                                            className="modal-content"
                                            overlayClassName="modal-overlay">
                                            <button
                                                onClick={closeSaveModal}
                                                className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
                                            <div>
                                            <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:py-0 py-2 md:h-[430px] flex flex-col items-center justify-center">

                                                    <div >
                                                        <div className="relative mb-4 w-full ">
                                                      
                                                            <div className="text-[14px] md:text-[48px] font-bold text-center w-full">
                                                                Save Successful
                                                            </div>
                                                        </div>
                                                        <p className="text-black text-[10px] md:text-[32px]  text-center mb-2">
                                                            The registration form
                                                            has been successfully
                                                            saved.
                                                        </p>
                                                        <button
                                                            onClick={
                                                                closeSaveModal
                                                            }
                                                            className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[10px] md:text-[32px] text-white w-[320px] md:w-[700px] h-[30px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>

                                        {/* Registration Confirmation Modal */}
                                        <Modal
                                            isOpen={isRegisterModalOpen}
                                            onRequestClose={closeRegisterModal}
                                            contentLabel="Registration Successful"
                                            className="modal-content"
                                            overlayClassName="modal-overlay">
                                            <button
                                                onClick={closeRegisterModal}
                                                className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                                                aria-label="Close">
                                                &times;
                                            </button>
                                            <div>
                                                <div className="relative bg-white p-0 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[430px]">
                                                    <div className="flex flex-col items-center justify-center text-center h-full w-full">
                                                        <div className="relative mb-4 w-full flex justify-center items-center">
                                                            <img
                                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                                                alt="Success"
                                                                className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                                            />
                                                            <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                                                Registration
                                                                Successful
                                                            </div>
                                                        </div>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-2">
                                                            Thank you for
                                                            registering with
                                                            Ad-Luck
                                                        </p>
                                                        <p className="text-black text-[10px] md:text-[32px] mb-4">
                                                            Your unique
                                                            registration number
                                                            is:
                                                        </p>
                                                        <div className="flex items-center justify-between w-full mb-6 mt-8 px-4">
                                                            <div className="flex-1 flex justify-center">
                                                                <span className="text-[12px] md:text-[32px] font-bold text-center md:ml-32 ml-5 tracking-wide">
                                                                    {
                                                                        registrationNumber
                                                                    }
                                                                </span>
                                                            </div>
                                                            <button
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        registrationNumber,
                                                                    );
                                                                    setCopyMessage(
                                                                        "Copied!",
                                                                    );
                                                                    setTimeout(
                                                                        () =>
                                                                            setCopyMessage(
                                                                                "",
                                                                            ),
                                                                        2000,
                                                                    );
                                                                }}
                                                                className="bg-[#F38323] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                                                Copy
                                                            </button>
                                                        </div>
                                                        {copyMessage && (
                                                            <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                                                {copyMessage}
                                                            </div>
                                                        )}
                                                        <a href="/">
                                                            <button
                                                                onClick={
                                                                    closeRegisterModal
                                                                }
                                                                className="bg-[#03897B] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[500px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                                                Continue to Home
                                                            </button>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </Modal>
                                    </div>


<a 
  href="#" 
  onClick={(e) => {
    e.preventDefault();
    navigate('/document', {
      state: {
        personalInfo: formData,
        organizationInfo: orgFormData,
        dropdownSelections,
        reportSelections,
        selectedLanguage,
        landData,
        selectedSkills,
        membershipData,
        selectedExperience,
        focusSelected,
        sectionD: {
          selectedType,
          selectedOption,
          selectedCategories
        },
        industry: {
          selectedChallenges,
          vision
        },
        setaQualification: {
          selectedS,
          selectedQ
        },
        location: userLocation,
        registrationNumber,
        idDocumentUrl,
        profileImage,
        productImages,
        certificatesUrls
      }
    });
  }}
>
  <div>
    <div className="flex w-fit">
      <button className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[50px] h-[15px] md:h-[44px] bg-[#152C24] text-white font-bold flex items-center px-1 rounded-l-[5px]`}>
        <div className="md:text-[16px] md:px-2 text-[4px] font-cold md:mt-0 mt-[2px] bg-transparent outline-none placeholder-white">SHARE REGISTRATION</div>
      </button>
      <div className="w-[15px] h-[15px] md:h-[44px] md:w-[50px] bg-[#FDBB26] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
          alt="expand"
          className="w-2 h-[10px] md:w-6 md:h-[24px]"
        />
      </div>
    </div>
    <p className="md:text-[14px] text-[4px] font-normal mt-1 text-black">
      Save registration 
    </p>
  </div>
</a>
                                </div>
                            </div>
{/* Error display */}
{registrationError && (
  <div className="text-red-500 text-center mt-2">
    {registrationError}
  </div>
)}
                    <Modal
                        isOpen={isModalOpen}
                        onRequestClose={() => setIsModalOpen(false)}
                        contentLabel="Registration Successful"
                        className="modal-content"
                        overlayClassName="modal-overlay"
                        style={{
                            overlay: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                zIndex: 1000,
                            },
                            content: {
                                position: "relative",
                                inset: "auto",
                                width: "80%",
                                maxWidth: "800px",
                                margin: "0 auto",
                            },
                        }}>
                        <button
                            onClick={() => setIsModalOpen(false)}
                            className="absolute top-1 right-4 text-black opacity-30 hover:text-black text-[30px] font-light z-50"
                            aria-label="Close">
                            &times;
                        </button>
                        <div>
                            <div className="relative bg-white p-4 md:pt-5 rounded-lg w-[350px] md:w-[800px] mx-auto md:h-[450px]">
                                <div className="flex flex-col items-center justify-center text-center h-full w-full">
                                    <div className="relative mb-4 w-full flex justify-center items-center">
                                        <img
                                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746440276/image_72_ifcxcp.png"
                                            alt="Success"
                                            className="absolute left-2 top-1/2 transform -translate-y-1/2 w-[24px] h-[24px] md:w-[60px] md:h-[60px]"
                                        />
                                        <div className="text-[16px] md:text-[48px] font-bold text-center w-full">
                                            {isLoggedIn
                                                ? "Update Successful"
                                                : "Registration Successful"}
                                        </div>
                                    </div>
                                    <p className="text-black text-[10px] md:text-[32px] mb-2">
                                        {isLoggedIn
                                            ? "Your details have been updated successfully!"
                                            : `Thank you for registering with Ad-Luck`}
                                    </p>
                                    {!isLoggedIn && (
                                        <p className="text-black text-[10px] md:text-[32px] mb-4">
                                            Your unique registration number is:
                                        </p>
                                    )}
                                    {!isLoggedIn && (
                               <div>
                               <div className="flex-1 flex justify-center">
                                                <span className="text-[12px] md:text-[36px] font-bold text-center tracking-wide">
                                                    {registrationNumber}
                                                </span>
                                            </div>
                                      
                               </div>
                               
                                    )}
                                    <div className="flex items-center justify-between w-full mb-6 md:mt-8 md:px-10 ">
                                        <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748558039/image_1738_biv82f.png"  alt=".." className="md:w-[70px] w-[20px] h-[20px] md:h-[70px]"/>
                                       
                                            <button
                                                onClick={() => {
                                                    navigator.clipboard.writeText(
                                                        registrationNumber,
                                                    );
                                                    setCopyMessage("Copied!");
                                                    setTimeout(
                                                        () => setCopyMessage(""),
                                                        2000,
                                                    );
                                                }}
                                                className="bg-[#EEB527] hover:bg-orange-600 text-white font-light text-[10px] md:text-[32px] md:w-[140px] md:h-[60px] px-4 py-2 rounded-[10px]">
                                                Copy
                                            </button>
                                        </div>
                                    {copyMessage && (
                                        <div className="text-black text-[14px] md:text-[18px] font-semibold">
                                            {copyMessage}
                                        </div>
                                    )}
                                    <a href="/">
                                        <button
                                            onClick={() => setIsModalOpen(false)}
                                            className="bg-[#152C24] md:mt-3 hover:bg-[#1b4a46] text-[12px] md:text-[32px] text-white w-full md:w-[700px] h-[40px] md:h-[56px] px-5 py-1 rounded-md font-bold">
                                            Continue to Home
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Modal>
              {/* App Download Section */}
              <div className="md:h-4"></div>
                    <h1 className="md:text-[36px] text-[10px] font-bold md:mt-8 mt-1 mb-4">
                        Download App
                    </h1>
                    <div className="flex  justify-between gap-8 md:gap-0  items-center">
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_903_oqescj.png" className="h-[25px] md:h-[76px]" alt="App Store" />
            <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744414874/image_scynki.png" className="h-[25px] md:h-[76px]" alt="Google Play" />
            <div>
                                            <button
                                                className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[46px] bg-[#2E453D] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] px-4"
                                                onClick={handleSaveClick}>
                                                <span>ADMIN</span>
                                                <img
                                                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747168118/User_cicrle_duotone_kaenga.png"
                                                alt="Edit Icon"
                                                className="md:w-[35px] h-2  md:h-[38px] w-2"
                                            />
                                            </button>
                                            <p className="md:text-[14px] text-[6px]  mt-1 font-normal md:px-1">
                                            For officaial use only
                                            </p>
                                        </div>
          </div>
                    <div className="md:h-4"></div>
                </div>
            </div>
        </div>
    );
};

export default RegisterOrganizaton;
